import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./features.css";

const FeatureData = [
  {
    title: "Quick Learning",
    desc: "Quick Learning: Accelerate your expertise with our fast-paced, effective learning programs designed for rapid skill enhancement",
    icon: "ri-draft-line",
  },

  {
    title: "All Time Support",
    desc: "Our commitment extends beyond learning hours, providing continuous support to ensure your success and address any challenges you encounter",
    icon: "ri-discuss-line",
  },

  {
    title: "Certification",
    desc: "Receive recognized certifications, validating your skills and enhancing your professional credentials",
    icon: "ri-contacts-book-line",
  },
];

const Features = () => {
  return (
    <section>
      <Container>
        <Row>
          {FeatureData.map((item, index) => (
            <Col lg="4" md="6" key={index}>
              <div className="single__feature text-center px-4">
                <h2 className="mb-3">
                  <i class={item.icon}></i>
                </h2>
                <h6>{item.title}</h6>
                <p>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
